// extracted by mini-css-extract-plugin
export default {"root":"ManualLoanEntryStep_root__zJIck","buttonContainer":"ManualLoanEntryStep_buttonContainer__Z3aT1"};